/* tslint:disable */
/* eslint-disable */
export enum WorkItemCalculatedByEntityEnum {
  ProjectHouseSide = 'ProjectHouseSide',
  Project = 'Project'
}
